export default class Swal {
  /**
   * =====
   * SWAL
   * =====
   */

  reset() {
    swal.resetDefaults();
    this.setDefaults();
  }

  setDefaults(params) {
    const parameters = {
      confirmButtonClass: 'color-primary',
      cancelButtonClass: 'color-default',
      cancelButtonText: 'Sair',
    };

    if (params) Object.assign(parameters, params);

    swal.setDefaults(parameters);
  }

  showImage(link) {
    this.reset();
    this.show({
      html: `<a href="${link}" target="_blank" download>Baixar</a>`,
      imageUrl: link,
      animation: false,
      confirmButtonText: 'Fechar',
    });
  }

  close() {
    swal.close();
  }

  cancel() {
    swal.clickCancel();
  }

  show(params) {
    this.reset();
    return swal(params);
  }

  connectionError(showInfo) {
    if (!showInfo) showInfo = '';
    this.reset();
    this.show({
      type: 'warning',
      confirmButtonText: 'Ok, entendi',
      html: `
        <h3><strong>Algum imprevisto aconteceu!</strong></h3>
        <div class="text-left" style="text-align: justify">
          <p>Nosso sistema pode estar fora do ar, ou você pode ter perdido a conexão com a internet.</p>
          <p>Certifique-se de que não há nenhum bloqueio em seu antivirus que possa impedir a navegação no sistema.</p>
          <p>Caso o problema persista, entre em contato conosco.</p>
        </div>
        <p><small>${showInfo}</small></p>
      `,
    });
  }

  queue(arrayParam, defaultParam) {
    this.reset();
    if (defaultParam) this.setDefaults(defaultParam);
    return swal.queue(arrayParam);
  }

  insertQueueStep(params) {
    return swal.insertQueueStep(params);
  }
  /* sessionError() {
    this.reset();
    this.show({
      confirmButtonText: 'Ok, entendi',
      html: `
        <h3><strong>Você não está autenticado ou sua sessão expirou!</strong></h3>
        <div class="text-left" style="text-align: justify">
            <p>Para continuar utilizando o portal, autentique-se novamente.</p>
        </div>
      `
    });
  } */
}
